import React from 'react';
import { Component } from '@poa/core';
import CalendarsTableSidebar from '../calendar-table/calendars-table-sidebar';
import CalendarsTableHeader from '../calendar-table/calendars-table-header';
import CalendarsTable from '../calendar-table/calendars-table';
import { DateModeCalendar } from '../table-filter';
import TD from '../calendar-table/calendars-table-datacell';
import Spinner from 'react-spinkit';

class DashboardCalendarComponent extends React.Component {
    store; // injected by Poa
    actions; // injected by Poa

    constructor(props) {
        super(props);
        this.localState = props.localState;
        this.name = props.name;
    }

    handleExpand = async (user) => {
        const { startDate, endDate, teamLead } = this.store.dashboard.filters;
        let newExpandedRows = [...this.localState.expandedRows];
        let idxFound = newExpandedRows.findIndex(name => {
            return name === user.name;
        });

        if (idxFound > -1) {
            newExpandedRows.splice(idxFound, 1);
        } else {
            newExpandedRows.push(user.name);
            try {
                const response = await this.env.api.calendar2.fetchCalendarExpandable(
                    this.localState.currentPageMode,
                    this.localState.currentDateMode,
                    startDate.unix(),
                    endDate.unix(),
                    user.userId,
                    teamLead
                );
                this.actions.dashboardActions.fetchExpandableSuccess(response);
            } catch (e) {
                console.error(e);
                this.actions.dashboardActions.fetchFailed();
                throw e;
            }
        }

        this.localState.expandedRows = [...newExpandedRows];
    };

    getRows = (rate, idx) => {
        let rows = [];
        const users = rate.teamLeads || [];

        const firstRow = (

            <React.Fragment key={idx}>
                <tr>
                    <th scope='row' className='calendar_type'>
                        <button
                            className='expand-button'
                            style={{ fontWeight: this.localState.expandedRows.includes(rate.name) ? '600' : '300', color: 'white' }}
                            onClick={() => this.handleExpand(rate)}
                        >
                            {rate.name || 'ФИО'}
                        </button>
                    </th>
                </tr>
            </React.Fragment>
        );

        rows.push(firstRow);

        if (this.localState.expandedRows.includes(rate.name) && users.length > 0) {
            const userRows = users.map((user, userIdx) => (
                <React.Fragment key={idx + userIdx}>
                    <tr>
                        <td style={{ textAlign: 'right', color: 'white' }}>
                            {user.name}
                        </td>
                    </tr>
                </React.Fragment>
            ));
            rows.push(userRows);
        }
        return rows;
    };

    getTableRows = rate => {
        let rows = [];
        const users = rate.teamLeads || [];

        const color_rate_active = rate.total >= rate.totalPlan ? 'green' : 'rgba(244, 110, 106)';
        const isNotRowExpanded = this.localState.expandedRows.length === 0;

        const firstRow = (
            <React.Fragment>
                <tr>
                    <React.Fragment>
                        <TD
                            item={{
                                amount: rate.total,
                                color: (this.localState.expandedRows.includes(rate.name) || isNotRowExpanded) ? color_rate_active : '#494545',
                                backgroundColor: (this.localState.expandedRows.includes(rate.name) || isNotRowExpanded) ? 'rgba(255, 255, 255, 0.83)' : '#ecebeb'
                            }}
                            borderBottom
                            borderRight
                        />
                    </React.Fragment>
                    {rate.data.map((d, idx) => (
                        <React.Fragment key={idx}>
                            <TD
                                item={{
                                    amount: d.amount,
                                    color: (this.localState.expandedRows.includes(rate.name) || isNotRowExpanded) ? (d.amount > d.plan) ? 'green' : 'rgba(244, 110, 106)' : '#494545',
                                    size: (this.localState.expandedRows.includes(rate.name) || isNotRowExpanded) ? '12px' : '9px',
                                    backgroundColor: (this.localState.expandedRows.includes(rate.name) || isNotRowExpanded) ? (d.is_weekend) ? 'yellow' : 'rgba(255, 255, 255, 0.83)' : '#e1e1e1'
                                }}
                                borderBottom
                                borderRight
                            />
                        </React.Fragment>
                    ))}
                    <React.Fragment>
                        <TD
                            item={{
                                amount: rate.total,
                                color: (this.localState.expandedRows.includes(rate.name) || isNotRowExpanded) ? color_rate_active : '#494545',
                                backgroundColor: (this.localState.expandedRows.includes(rate.name) || isNotRowExpanded) ? 'rgba(255, 255, 255, 0.83)' : '#ecebeb'
                            }}
                            borderBottom
                            borderRight
                        />
                    </React.Fragment>
                    <React.Fragment>
                        <TD
                            item={{
                                amount: rate.totalPlan,
                                backgroundColor: (this.localState.expandedRows.includes(rate.name) || isNotRowExpanded) ? 'transparent' : '#ecebeb'
                            }}
                            borderBottom
                            borderRight />
                    </React.Fragment>
                </tr>
            </React.Fragment>
        );

        rows.push(firstRow);

        if (this.localState.expandedRows.includes(rate.name) && users.length > 0) {
            const userRows = users.map(user => (
                <React.Fragment>
                    <tr>
                        <React.Fragment>
                            <TD
                                item={{
                                    amount: user.total,
                                    color: (user.total >= user.total_plan) ? 'green' : '#FFAEAC',
                                    backgroundColor: '#fff'
                                }}
                                borderBottom
                                borderRight />
                        </React.Fragment>
                        {user.days.map((d, idx) => (
                            <React.Fragment key={idx}>
                                <TD
                                    item={{
                                        amount: d.amount,
                                        color: (d.amount > d.plan) ? 'green' : '#FFAEAC',
                                        backgroundColor: '#fff'
                                    }}
                                    borderBottom
                                    borderRight />
                            </React.Fragment>
                        ))}
                        <React.Fragment>
                            <TD
                                item={{
                                    amount: user.total,
                                    color: (user.total >= user.total_plan) ? 'green' : '#FFAEAC',
                                    backgroundColor: '#fff'
                                }}
                                borderBottom
                                borderRight />
                        </React.Fragment>
                        <React.Fragment>
                            <TD item={{
                                amount: user.total_plan,
                                backgroundColor: 'transparent'
                            }} borderBottom borderRight />
                        </React.Fragment>

                    </tr>
                </React.Fragment>

            ));
            rows.push(userRows);
        }

        return rows;
    };

    getRatesTable = rates => {
        return rates.map((rate, idx) => {
            return this.getTableRows(rate, idx);
        });
    };

    getNameRatesTable = rates => {
        return rates.map((rate, idx) => {
            return this.getRows(rate, idx);
        });
    };

    render = () => {
        const { selectors, calendarLoading } = this.store.dashboard;

        return <div className='cards-badge dashboard-calendar-row' >
            <div className='cards-badge-header'>
                <p>{this.name}</p>
            </div>
            <div className='cards-badge-body-calendar'>
                {calendarLoading ? (
                    <div
                        className='spinner-loading'
                        style={{ paddingTop: '75px', textAlign: 'center' }}
                    >
                        <Spinner name='folding-cube' fadeIn='none' />
                    </div>
                ) : (
                    <div className='container calendar' 
                    style={{ 
                        padding: '5px', 
                        scrollbarWidth: 'none',
                        }}>
                        <div className='inner' style={{ padding: '5px', display: 'flex' }}>
                            <div>
                                <table>
                                    <thead>
                                        <tr style={{ maxHeight: '20px', height: '20px', backgroundColor: 'rgb(111, 111, 111)' }}>
                                            <th className='empty-first colored'>-</th>
                                        </tr>
                                        <tr style={{ maxHeight: '20px', height: '20px' }}>
                                            <th className='empty-first'>-</th>
                                        </tr>
                                    </thead>
                                </table>
                                <div style={{
                                    width: '200px',
                                    height: 'calc(100vh - 243px)',
                                    maxHeight: 'calc(100vh - 243px)',
                                    overflowY: "hidden"
                                }}
                                    ref={node => (this.sidebarEl = node)}
                                >
                                    <CalendarsTableSidebar
                                        rates={this.getNameRatesTable(selectors.usersData)}
                                    />
                                </div>
                            </div>
                            <div>
                                <div
                                    style={{ overflowX: 'hidden', width: 'calc(100vw - 280px)' }}
                                    ref={node => (this.headerEl = node)}
                                >
                                    <table>
                                        <CalendarsTableHeader
                                            rates={{
                                                days: this.localState.currentDateMode === DateModeCalendar.monthes ? selectors.monthToShow : selectors.daysToShow,
                                                weekDays: this.localState.currentDateMode === DateModeCalendar.monthes ? selectors.monthNameToShow : selectors.weekDaysToShow,
                                                data: selectors.usersData
                                            }}
                                            isDashboard={true}
                                        />
                                    </table>
                                </div>

                                <div className='table-container__body' style={{ width: 'calc(100vw - 280px)' }}>
                                    <CalendarsTable
                                        ref={node => (this.ratesTable = node)}
                                        getHeaderElement={() => this.headerEl}
                                        getSidebarElement={() => this.sidebarEl}
                                        rates={{
                                            days: this.localState.currentDateMode === DateModeCalendar.monthes ? selectors.monthToShow : selectors.daysToShow,
                                            weekDays: this.localState.currentDateMode === DateModeCalendar.monthes ? selectors.monthNameToShow : selectors.weekDaysToShow,
                                            data: this.getRatesTable(selectors.usersData)
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )}


            </div>
        </div>;
    };
};

export default Component()(DashboardCalendarComponent);
